import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function HelpSmall({
  fillPrimary = colors.neutral60,
  hoverFillPrimary,
  className,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(`group h-[16px] w-[16px]`, className)}
    >
      <g id="ic-help-s">
        <path
          id="Vector (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.00008 13.5C11.0376 13.5 13.5001 11.0376 13.5001 8C13.5001 4.96243 11.0376 2.5 8.00008 2.5C4.96251 2.5 2.50008 4.96243 2.50008 8C2.50008 11.0376 4.96251 13.5 8.00008 13.5ZM15.0001 8C15.0001 11.866 11.8661 15 8.00008 15C4.13408 15 1.00008 11.866 1.00008 8C1.00008 4.13401 4.13408 1 8.00008 1C11.8661 1 15.0001 4.13401 15.0001 8Z"
          fill={fillPrimary}
          className={hoverFillPrimary}
        />
        <path
          id="Ellipse 13"
          d="M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z"
          fill={fillPrimary}
          className={hoverFillPrimary}
        />
        <path
          id="Ellipse 14 (Stroke)"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 5.25C7.30964 5.25 6.75 5.80964 6.75 6.5C6.75 6.91421 6.41421 7.25 6 7.25C5.58579 7.25 5.25 6.91421 5.25 6.5C5.25 4.98122 6.48122 3.75 8 3.75C9.51878 3.75 10.75 4.98122 10.75 6.5C10.75 8.01878 9.51878 9.25 8 9.25C7.58579 9.25 7.25 8.91421 7.25 8.5C7.25 8.08579 7.58579 7.75 8 7.75C8.69036 7.75 9.25 7.19036 9.25 6.5C9.25 5.80964 8.69036 5.25 8 5.25Z"
          fill={fillPrimary}
          className={hoverFillPrimary}
        />
      </g>
    </svg>
  );
}
